import { lazy, Suspense } from 'react';
import LazyLoading from '../../components/LazyLoading';

const LazyAdminPromoCodes = lazy(
  () => import(/* webpackChunkName: 'AdminPromoCodes' */ './index'),
);

export default function AdminPromoCodes() {
  return (
    <Suspense fallback={<LazyLoading />}>
      <LazyAdminPromoCodes />
    </Suspense>
  );
}
